var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"order-view-actions-spec-payment-error"}},[(!_vm.isQuoteOwner)?_c('OrderViewActionAccept',{attrs:{"btn-icon":"CreditCardIcon","btn-text":_vm.$tc('payment.title', 1)}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }